// extracted by mini-css-extract-plugin
module.exports = {"dialog":"confirmDialog_dialog__1xplE","footerActions":"confirmDialog_footerActions__1JDk7"};